<template>
  <div v-if="show">
    <div class="menuFrame">
      <section id="login">
        <div class="container py-3">
          <div
            class="row flex-nowrap mx-2 pt-3 justify-content-between align-items-center"
          >
            <a href="https://www.chanchao.com.tw/">
              <div class="d-flex">
                <img
                  src="../../assets/images/ChanChaoLogo.png"
                  class="navLogo mt-2"
                />
                <div class="ml-2 mt-1 mt-md-0">
                  <div class="navHead font-weight-nomal">展昭會員</div>
                  <div class="text-muted navCnt">ChanChao Member</div>
                </div>
              </div>
            </a>
            <div>
              <select
                class="form-control language-select"
                v-model="selectedLang"
                @change="switchLanguage"
              >
                <option
                  v-for="lang in languages"
                  :key="lang.value"
                  :value="lang.value"
                >
                  {{ lang.label }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="row formFrame m-1 py-2 mr-3 justify-content-center">
            <div class="col-md-6 my-4 px-4">
              <div class="d-flex align-items-center">
                <img
                  src="../../assets/images/PwIcon.png"
                  class="mr-2 mb-2"
                  style="width: 40px; height: 40px"
                  alt=""
                />
                <h4>重設密碼</h4>
              </div>
              <p class="my-4">請重新設定您的登入密碼。</p>
              <form>
                <div class="form-group h6">
                  <label for="resetPassword1">新密碼</label>
                  <div class="input-group mb-3">
                    <input
                      type="password"
                      :type="typePwd"
                      class="form-control"
                      id="resetPassword1"
                      autocomplete="off"
                      placeholder="密碼長度 8-20 字元"
                      maxlength="20"
                      aria-describedby="emailHelp"
                      v-model="password"
                      name="password"
                      :class="{ 'is-invalid': errors.first('password') }"
                      v-validate="'required'"
                      ref="password"
                      data-vv-as="密碼欄位"
                    />
                    <div class="input-group-append">
                      <span
                        class="input-group-text"
                        id="basic-addon2"
                        @click.prevent="showPw"
                      >
                        <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                        <i
                          class="fas fa-eye-slash"
                          v-else="typePwd == 'text'"
                        ></i>
                      </span>
                    </div>
                  </div>
                  <span
                    class="text-danger"
                    style="font-size: 10px"
                    v-if="errors.first('password')"
                    >{{ errors.first("password") }}
                  </span>
                </div>

                <div class="form-group h6">
                  <label for="resetPassword2">新密碼確認</label>
                  <div class="input-group mb-3">
                    <input
                      type="password"
                      :type="typePwd"
                      class="form-control"
                      id="resetPassword2"
                      autocomplete="off"
                      placeholder="請再次輸入新密碼"
                      maxlength="20"
                      aria-describedby="emailHelp"
                      v-model="confirmcode"
                      name="password_confirmation"
                      :class="{
                        'is-invalid': errors.first('password_confirmation'),
                      }"
                      v-validate="'required|confirmed:password'"
                      data-vv-as="密碼確認欄位"
                      ref="passwordconfirm"
                    />

                    <div class="input-group-append">
                      <span
                        class="input-group-text"
                        id="basic-addon2"
                        @click.prevent="showPw"
                      >
                        <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                        <i
                          class="fas fa-eye-slash"
                          v-else="typePwd == 'text'"
                        ></i>
                      </span>
                    </div>
                  </div>
                  <span
                    class="text-danger"
                    style="font-size: 10px"
                    v-if="errors.first('password_confirmation')"
                    >{{ errors.first("password_confirmation") }}
                  </span>
                </div>
                <button
                  type="submit"
                  class="btn btn-block btn-primary mt-4"
                  @click.prevent="resetPw"
                >
                  更改密碼
                </button>
              </form>

              <div v-if="!Registered">
                <hr />

                <div class="linkFrame">
                  <a href="https://www.chanchao.com.tw/accounts/login"
                    >會員登入</a
                  >

                  <span class="linkText ml-2 pl-2">
                    <span class="linkLine"></span>
                    <a href="https://www.chanchao.com.tw/accounts/signup"
                      >立即註冊</a
                    >
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from "@/components/footer.vue";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      password: "",
      confirmcode: "",
      typePwd: "password",
      access_token: "",
      alertTitle: "",
      alertText: "",
      lastUrl: "",
      menberId: "",
      verifyCode: "",
      CSRF_Token: "",
      show: false,
      Registered: false,
      selectedLang: "tw",
      languages: [
        { label: "中文", value: "tw" },
        { label: "English", value: "en" },
        { label: "Tiếng Việt", value: "vn" },
        { label: "ភាសាខ្មែរ", value: "km" },
        { label: "ภาษาไทย", value: "th" },
        { label: "বাংলা ভাষা", value: "bd" },
      ],
    };
  },

  watch: {
    password: function () {
      const vm = this;
      vm.$refs.password.style.borderColor = "#ced4da";
    },

    confirmcode: function () {
      const vm = this;
      vm.$refs.passwordconfirm.style.borderColor = "#ced4da";
    },
  },

  methods: {
    switchLanguage() {
      const langCode = this.selectedLang;

      if (langCode === "tw") {
        window.location.href = `https://www.chanchao.com.tw/accounts/resetPw`;
      } else {
        window.location.href = `https://www.chanchao.com.tw/accounts/${langCode}/resetPw`;
      }
    },
    resetPw() {
      const vm = this;
      const url = "https://www.chanchao.com.tw/apiLogin2/resetPw";
      const resetinfo = {
        spass: vm.password,
        c: vm.verifyCode,
        e: vm.menberId,
        CSRF: vm.CSRF_Token,
      };

      vm.$validator.validate().then((valid) => {
        if (valid) {
          if (vm.password.length > 7) {
            vm.$http.post(url, resetinfo).then(function (response) {
              // // console.log(response)
              if (response.data == "200") {
                vm.alertTitle = "成功";
                vm.alertText = "您的密碼已重設成功，請使用新密碼重新登入！";
                vm.alertSuccess();
              } else if (response.data == "252") {
                window.location.replace("https://www.chanchao.com.tw/");
              } else {
                vm.alertText = "系統忙碌，請稍後登入！";
                vm.alertError();
              }
            });
          } else {
            vm.alertText = "密碼請輸入 8-20 字元！";
            vm.alertError();
            vm.$refs.password.style.borderColor = "red";
            vm.$refs.passwordconfirm.style.borderColor = "red";
          }
        } else {
          vm.alertText = "輸入欄位不完整，請重新檢查！";
          vm.alertError();
        }
      });
    },

    alertError() {
      const vm = this;
      vm.$swal({
        title: vm.alertTitle,
        text: vm.alertText,
        icon: "info",
        confirmButtonText: "OK",
        // animation: false,
        allowOutsideClick: true,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      });
    },

    alertSuccess() {
      const vm = this;

      vm.$swal({
        title: vm.alertTitle,
        text: vm.alertText,
        icon: "success",
        confirmButtonText: "OK",
        // animation: false,
        allowOutsideClick: true,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      }).then(function () {
        const url = "https://www.chanchao.com.tw/apiLogin2/Logout";

        vm.$http.get(url).then(function (response) {
          document.location.href = "https://www.chanchao.com.tw/accounts/login";
        });
      });
    },

    showPw() {
      const vm = this;
      vm.typePwd = vm.typePwd === "password" ? "text" : "password";
    },
  },

  created() {
    const vm = this;

    vm.$http
      .get("https://www.chanchao.com.tw/apiLogin2/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    let getUrlString = location.href;
    let getParams = new URL(getUrlString);

    let memberid = getParams.searchParams.get("e");
    let vCode = getParams.searchParams.get("c");

    vm.menberId = memberid;
    vm.verifyCode = vCode;

    const url = `https://www.chanchao.com.tw/apiLogin2/resetPw/${memberid}/${vCode}`;

    vm.$http.get(url).then(function (response) {
      if (response.data == 251 || response.data == 252) {
        alert("連結已失效，請重新申請。");
        vm.$router.push({ path: "/forgetPw" });
      } else {
        vm.show = true;
      }
    });

    //更換英文語系
    vm.$i18n.locale = "zhTW";

    //是否登入狀態

    const url2 = "https://www.chanchao.com.tw/apiLogin2/isAuthenticated";
    const info = null;

    vm.$http.post(url2, info).then(function (response) {
      // console.log(response.data)
      if (response.data == 200) {
        vm.Registered = true;
      } else {
        vm.Registered = false;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
//Swal setting

.swal2-popup {
  font-size: 13px !important;
}

.swal2-styled.swal2-confirm {
  font-size: 10px;
}

#main-footer {
  bottom: 0;
}

.menuFrame {
  background-color: #f2f2f2;
  min-height: 100%;
}

.formFrame {
  background-color: #ffffff;
  margin-top: 40px;
  border-radius: 10px;
  box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
}

.navEnText:hover {
  color: rgb(34, 34, 34) !important;
}

.navHead {
  font-size: 29px;
  color: #2c3e50;
}

.navCnt {
  font-size: 17px;
}

.navLogo {
  height: 55px;
}

@media (max-width: 768px) {
  .lineBottom {
    border-top: 0.5px solid rgb(230, 227, 227);
    padding-top: 30px;
  }

  .navEnText {
    display: none;
  }

  .navHead {
    font-size: 23px;
    color: #2c3e50;
  }

  .navCnt {
    font-size: 14px;
  }

  .navLogo {
    height: 50px;
  }
}

@media (max-width: 992px) {
  .auth-code {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

.input-note {
  font-size: 14px;
  color: rgb(190, 67, 67);
}

input::-webkit-input-placeholder {
  /* placeholder*/
  color: #aab2bd;
  font-size: 14px;
}

.linkFrame {
  font-size: 15px;
}

.linkText {
  position: relative;
}

.linkLine {
  position: absolute;
  height: 13px;
  //width: 33px;
  top: 20%;
  left: 0;
  border-left: 2px solid #a1a7a8;
}
</style>
